import React from 'react'
import home from "../assets/images/home.jpg"

const HomeBanner = (props) => {
  console.log('props11111111: ', props);

  if (!props.data || !props.data.banner_image) {
    return (
      <div className="w-full h-[750px] flex items-center justify-center bg-gray-200">
        {/* Placeholder or loading spinner */}
        <div className="spinner">Loading...</div>
      </div>
    );
  }

  return (
    <div
      className="relative w-full h-[300px] sm:h-[450px] md:h-[600px] lg:h-[750px] flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${props.data.banner_image})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#5E35B14D]"></div>

      {/* Title */}
      <h1
        className="
      relative z-10 text-white 
      text-3xl sm:text-4xl md:text-6xl lg:text-7xl 
      font-bold text-center 
      leading-snug sm:leading-tight md:leading-[80px] lg:leading-[100px]
      tracking-tight px-4 max-w-6xl
    "
      >
        {props.data?.tagline || ""}
      </h1>
    </div>

  );
};


export default HomeBanner